import { KeyboardArrowDown } from '@material-ui/icons';
import styled from 'styled-components';

export const ChatListContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	background-color: #fff;
	overflow-y: auto;
	border-right: 1px solid #e0e0e0;
	overflow-y: auto;

`;

export const ChatList = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background-color: #fff;
	border-right: 1px solid #e0e0e0;
	padding-top: 8px;
`;

export const ChatListItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 16px;
	border-bottom: 1px solid #f0f2f5;
	background-color: ${props => props.selected ? '#f0f2f5' : '#fff'};
	cursor: pointer;
	transition: all 0.2s ease;
	width: 100%;

	&:hover {
		background-color: #f5f6f6;
		padding-right: 24px;

		.chat-content {
			transform: translateX(-8px);
		}

		.status-button {
			opacity: 1;
		}
	}

	&[data-ended="true"] {
		opacity: 0.7;
		cursor: default;

		&:hover {
			background-color: #fff;
			padding-right: 16px;
      cursor: default;

			.chat-content {
				transform: none;
			}
		}

		.status-button {
			display: none;
		}
	}
	&[data-pending="true"] {
		.status-button {
			opacity: 1;
		}
	}
`;

export const AnimatedArrowIcon = styled( KeyboardArrowDown )`
  transition: opacity 1.5s ease-in-out;
  opacity: ${( { isHovered } ) => isHovered ? 1 : 0};
  cursor: pointer;
  margin-left: 4px;
	color: #54656f;

  &:hover {
    opacity: 1;
  }
`;

export const ChatListAvatar = styled.div`
	margin-right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const ChatListInfo = styled.div`
	flex: 1;
	min-width: 0;
	margin-left: 12px;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const ChatContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: hidden;
	transition: transform 0.2s ease;
`;

export const ChatListName = styled.div`
	font-weight: 500;
	color: #111b21;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
`;

export const ChatListResponsible = styled.div`
	display: flex;
	width: 100%;
`;

export const ChatListResponsibleText = styled.p`
	padding: 2px 12px;
	background-color: #f0f2f5;
	font-weight: 600;
	border-radius: 12px;
	font-size: 10px;
	color: #667781;
	margin: 2px 0;
`;

export const OfficialChatBadge = styled.span`
	display: inline-flex;
	align-items: center;
	background-color: #25D366;
	color: white;
	font-size: 8px;
	font-weight: 700;
	letter-spacing: 0.3px;
	padding: 1px 4px;
	border-radius: 3px;
	text-transform: uppercase;
	flex-shrink: 0;
`;

export const ChatListMessage = styled.div`
	color: #667781;
	font-size: 14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
`;
export const MessageTimeText = styled.span`
	font-size: 12px;
	color: #00a884;
`;

export const ChatListUnreadCountContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;



export const ChatListUnreadCount = styled.span`
	gap: 8px;
	background-color: #00a884;
	color: white;
	border-radius: 12px;
	padding: 1px 6px;
	font-size: 12px;
	text-align: center;
`;

export const LoadMoreButton = styled.button`
	padding: 12px;
	background: none;
	border: none;
	color: #00a884;
	cursor: pointer;
	font-weight: 500;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #f5f6f6;
	}
`;

export const ToggleButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: calc(100% - 32px);
	margin: 16px;
	padding: 12px 16px;
	background-color: #f0f2f5;
	color: #54656f;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.2s ease;

	&:hover {
		background-color: #e4e6e8;
	}

	&:active {
		background-color: #d9dbdd;
	}

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const StatusButton = styled.button`
	width: 18px;
	height: 18px;
	padding: 0;
	border: 1px solid #00a884;
	cursor: pointer;
	opacity: 0;
	transition: all 0.2s ease;
	background-color: ${props => props.status === 'Pendente' ? '#00a884' : 'transparent'};
	color: transparent;
	border-radius: 50%;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 16px 10px;
	padding-bottom: 20px;
	border-bottom: 1px solid #e0e0e0;
	width: 100%;
	flex-wrap: wrap;
`;

export const FilterButton = styled.button`
	padding: 8px 6px;
	background-color: ${props => props.active ? '#00a884' : '#f0f2f5'};
	color: ${props => props.active ? 'white' : '#54656f'};
	border: none;
	cursor: pointer;
	font-size: 12px;
	font-weight: 500;
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 24px;

	&:hover {
		background-color: ${props => props.active ? '#008f72' : '#e4e6e8'};
		z-index: 10;

		svg {
			transform: scale(1.1);
		}
	}

	.filter-text {
		opacity: 1;
		width: auto;
		white-space: nowrap;
		transition: all 0.3s ease;
		margin-left: 0;
		margin-top: 2px;
		overflow: hidden;
		font-size: 11px;
		text-align: center;
	}

	svg {
		width: 20px;
		height: 20px;
		flex-shrink: 0;
		transition: transform 0.3s ease;
	}
`;

export const ChatListHeaderContainer = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 16px;
	background-color: #f0f2f5;
	border-bottom: 1px solid #e0e0e0;
	gap: 8px;
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: 8px 12px;
	border: none;
	border-radius: 8px;
	background-color: #fff;
	font-size: 14px;
	color: #111b21;
	outline: none;

	&::placeholder {
		color: #667781;
	}
`;

export const DropdownMenu = styled.div`
	position: absolute;
	top: 110%;
	right: 16px;
	background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	border: 1px solid #e0e0e0;
	z-index: 1000;
	min-width: 180px;
	opacity: ${props => props.isOpen ? 1 : 0};
	visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
	transform: ${props => props.isOpen ? 'translateY(-50%)' : 'translateY(calc(-50% - 10px))'};
	transition: all 0.2s ease;
`;

export const DropdownItem = styled.div`
	padding: 12px 16px;
	cursor: pointer;
	font-size: 14px;
	color: #111b21;
	display: flex;
	align-items: center;
	gap: 12px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #f5f6f6;
	}

	&:first-child {
		border-radius: 8px 8px 0 0;
	}

	&:last-child {
		border-radius: 0 0 8px 8px;
	}

	&:only-child {
		border-radius: 8px;
	}

	svg {
		width: 18px;
		height: 18px;
		color: #54656f;
	}
`;

export const DropdownOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 999;
	display: ${props => props.isOpen ? 'block' : 'none'};
`;

export const ResponseTimeText = styled.span`
	font-size: 10px;
	color: #667781;
	padding: 2px 6px;
	border-radius: 6px;
	background-color: #f0f2f5;
	font-weight: 600;
`;
export const PhoneNumberIsActiveBlock = styled.div`
	position: absolute;
	top: 8px;
	left: 8px;
	z-index: 999;
	display: ${props => props.isOpen ? 'block' : 'none'};
`;

export const RightSideContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 8px;
`;
